module.exports = __webpack_public_path__ + "img/INT_DM.fc4c8555.png";